module.exports = require('./PrinterView');
